module.exports = require('./PrinterView');
